import React from 'react';
import { styled } from '@linaria/react';
import { BottomSheet } from '@daedalus/atlas/BottomSheet';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { PopUp } from '@daedalus/atlas/PopUp';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { calculateChargeDate, hasChargeLaterTag } from '@daedalus/core/src/offer/business/chargeLater';
import { Offer } from '@daedalus/core/src/offer/types/offer';
import { RoomConfigurationType } from '@daedalus/core/src/room/types/RoomConfiguration';
import { calculateDateDifference } from '@daedalus/core/src/utils/date';
import PriceDetails from '../PriceDetailsV2';
import { RoomDetailsSection } from '../RoomDetailsSection';
export interface PriceBreakdownModalProps {
  checkIn: string;
  checkOut: string;
  roomsConfig: RoomConfigurationType;
  roomName: string;
  offer: Offer;
  isOpen: boolean;
  onClose: () => void;
  prefersReducedMotion?: boolean;
  propertyCurrencyCode?: string;
}
const RoomDetailsWrapper = /*#__PURE__*/styled('div')({
  name: "RoomDetailsWrapper",
  class: "r1m28zkt",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ContentWrapper;
const DesktopContentWrapper = /*#__PURE__*/styled(_exp2())({
  name: "DesktopContentWrapper",
  class: "dmdfe06",
  propsAsIs: true
});
const Title = () => <Text variant="titleM">
    <FormattedMessageWrapper id="priceBreakdown" defaultMessage="Price Breakdown" />
  </Text>;
export const PriceBreakdownModal = ({
  checkIn,
  checkOut,
  roomsConfig,
  roomName,
  offer,
  isOpen = false,
  onClose,
  prefersReducedMotion,
  propertyCurrencyCode
}: PriceBreakdownModalProps) => {
  const {
    isMobile
  } = useDeviceLayout();
  const numberOfNights = calculateDateDifference(new Date(checkIn), new Date(checkOut));
  const isOfferChargeLaterEligible = hasChargeLaterTag(offer);
  const chargeLaterDate = offer && calculateChargeDate(offer.cancellationPenalties);
  const Content = () => <div data-id="priceBreakdownComponent">
      <RoomDetailsWrapper>
        <RoomDetailsSection showRoomDetails={isOfferChargeLaterEligible} numberOfNights={numberOfNights} numberOfRooms={roomsConfig.numberOfRooms} roomName={roomName} cancellationPenalties={offer.cancellationPenalties} canPayLater={offer.canPayLater} offerPrices={offer.prices} includeNumberOfRooms isLoading={!offer} isChargeLaterEligible={isOfferChargeLaterEligible} chargeLaterDate={chargeLaterDate || undefined} chargeLaterClickAction="tooltip" />
      </RoomDetailsWrapper>
      <PriceDetails showFeesDescriptions={false} showCurrencySelector={false} checkIn={checkIn} checkOut={checkOut} numberOfGuests={roomsConfig.numberOfAdults + roomsConfig.numberOfChildren} numberOfRooms={roomsConfig.numberOfRooms} merchantOfRecord={offer.merchantOfRecord} prices={offer.prices} propertyCurrencyCode={propertyCurrencyCode} />
    </div>;
  return <>
      {isMobile ? <BottomSheet isOpen={isOpen} titleBarProps={{
      centerContent: <Title />
    }} onClose={onClose} prefersReducedMotion={prefersReducedMotion}>
          <Content />
        </BottomSheet> : <PopUp width={600} isOpen={isOpen} titleBarProps={{
      centerContent: <Title />
    }} closeAction={onClose}>
          <DesktopContentWrapper>
            <Content />
          </DesktopContentWrapper>
        </PopUp>}
    </>;
};

require("./PriceBreakdownModal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceBreakdownModal.tsx");